import store from './store';
import EventBus from './event-bus';

let defaultOptions = {
  height: "auto",
  scrollable: false,
  adaptive: true,
  focusTrap: true,
  classes: "bmi-modal",
  width: "900px",
};

let defaultTemplate = (content, tagName) => {
    return  {template: `
    <div class="bmi-modal__wrapper" data-tag-trigger="visible" data-tag-meta='{"type": "overlay", "title": "${tagName ? tagName : `Contextual Overlay`}", "name": "Contextual Overlay", "no": "01"}'>
        <button class="bmi-modal__close" @click="$emit('close')"></button>

        <div class="bmi-modal__row">
            <div class="bmi-modal__area bmi-modal__area-body">
                ${content}
            </div>
        </div>
    </div>
    `}
};

let videoTemplate = (id, title) => {
    return {template: `
        <div class="bmi-modal__wrapper" data-tag-trigger="visible" data-tag-meta='{"type": "overlay", "title": "Video Overlay", "name": "Contextual Overlay", "no": "01"}'>
        <button class="bmi-modal__close" @click="$emit('close')"></button>
            <div class="bmi-modal__content">
                ${title ? `<p class="bmi-modal__video-title">${title}</p>` : ``}
                <div class="bmi-modal__video-container">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/${id}" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
            </div>
        </div>
    `}
};

const modalConstructor = (Template, Name, Options, Events) => (
    {
        template: Template,
        name: {name: Name},
        options: {
            name: Name,
            ...defaultOptions,
            ...Options
        },
        events: Events
    }
)

const videoModal = modalConstructor(
    (id, title) =>  videoTemplate(id, title),
    "video",
    {classes: 'bmi-modal bmi-modal--video'},
)

const releaseNotesModal = modalConstructor(
    (content) => defaultTemplate(`${content}`, 'Release Notes Overlay'),
    "releaseNotes",
    {classes: 'bmi-modal bmi-modal--release-notes'}
)

const applicationsModal = modalConstructor(
    defaultTemplate('', 'Market Applications Overlay'),
    "applications",
    {classes: 'bmi-modal bmi-modal--applications'},
    (apps) => ({
        'opened': () => {
                // console.log("before open");
                let container = document.querySelector('.bmi-modal--applications .bmi-modal__area-body');
                container.appendChild(apps);
            }
    }),
)

const quickLinksModal = modalConstructor(
    defaultTemplate('', 'Quick Links Overlay'),
    "quickLinks",
    {classes: 'bmi-modal bmi-modal--quick-links'},
    (links) => ({
        'opened': () => {
                // console.log("before open");
                let container = document.querySelector('.bmi-modal--quick-links .bmi-modal__area-body');
                container.appendChild(links);
            }
    }),
)

const patentsModal = modalConstructor(
    defaultTemplate('', 'Patents Overlay'),
    "patents",
    {classes: 'bmi-modal bmi-modal--patents'},
    (content) => ({
        'opened': () => {
                // console.log("before open");
                // console.log(content);
                let container = document.querySelector('.bmi-modal--patents .bmi-modal__area-body');
                container.appendChild(content);
            }
    }),
)

const tooltipModal = modalConstructor(
    (content) => defaultTemplate(`${content}`, 'Tooltip Overlay'),
    "tooltip",
    {classes: 'bmi-modal bmi-modal--tooltip'}
);

const formModal = {
    template: (content) => defaultTemplate(
            `${content.copy ? `
            <div class="bmi-modal__copy">
                ${content.copy}
            </div>
            ` : ``}
            <div class="bmi-modal__form">
            <iframe src="${content.url}" width="100%" height="500" type="text/html" frameborder="0" allowTransparency="true" style="border: 0"></iframe>
            </div>`, 'Form Overlay'
        ),
    name: (value) => ({"name": value}),
    options: (data) => ({
        ...defaultOptions,
        classes: 'bmi-modal bmi-modal--form',
        ...data
    }),
    events: (data) => ({
        'opened': () => {
            let id = store.state.GAID;

            var iframe = document.querySelector(".bmi-modal__form iframe");
            let src = document.querySelector(".bmi-modal__form iframe").getAttribute('src');
            let paramData = {
                ...data,
                GAID: id
            };

            window.addEventListener("message", (event) => {
                // console.log(event);
                if (event.origin == "https://info.badgermeter.com") {
                    sizeIframe(event);
                    postData(event);
                    receiveData(event);
                }
            });

            const postData = (event) => {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(JSON.stringify(paramData), '*');
                } else {
                    iframe.onload = function() {
                        iframe.contentWindow.postMessage(JSON.stringify(paramData), '*');
                    }
                }
            }
        
            const sizeIframe = (event) => {
                try {
                    let data = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
                    // console.log(data);
                    if (data.form) {
                        if ( src.includes(data.form) ) {
                            iframe.style.height = `${data.content + 20}px`;
                        }
                    }
                } catch (e) { console.log("Unexpected message", e); }
            };

            const receiveData = (event) => {
                try {
                    let eventData = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
                    eventData = {
                        eventData, //pass data from postmessage event
                        ...data //also pass data from modal trigger event
                    }
                    if (eventData.eventData.submit) {
                        // emit submitted event whenever a form is submitted
                        EventBus.$emit('form-submitted', eventData);
                    }
                } catch (e) { console.log("Unexpected message", e); }
            }
        },
        'closed' : () => {
            // emit form closed event whenever form is closed
            EventBus.$emit('form-closed', data);
        }
    })
}

const infoModal = modalConstructor(
     (title, content) => defaultTemplate(`
        <h2 class="bmi-modal__title">
            ${title}
        </h2>
        <div class="bmi-modal__copy">
            ${content}
        </div>
    `, 'Info Overlay'),
    "contact",
    { width:'none', height: 'none', shiftY: 0, classes: 'bmi-modal bmi-modal--info'},
    {
        opened: () => {
            const body = document.querySelector("body");
            body.classList.add('bmi-modal__body');
        },
        closed: () => {
            const body = document.querySelector("body");
            body.classList.remove('bmi-modal__body');
        }
    }
);

const genericModal = modalConstructor(
    (content) =>  defaultTemplate(content, "Content Overlay"),
    "generic",
    {classes: 'bmi-modal bmi-modal--generic'},
)

const exitModal = modalConstructor(
    (content) =>  {return {template: `
    <div class="bmi-modal__wrapper" data-tag-trigger="visible" data-tag-meta='{"type": "overlay", "title": "External Link Overlay", "name": "Contextual Overlay", "no": "01"}'>
        <div class="bmi-modal__row">
            <div class="bmi-modal__area bmi-modal__area-body">
                ${content.copy}
            </div>
        </div>
        <div class="bmi-modal__row">
            <div class="bmi-modal__area bmi-modal__area-buttons">
                <a href="${content.link}" class="button primary-button"><span class="button-text"></span>${content.ok}<span class="button-icon"></span></a>
                <a href="#" v-on:click.prevent="$emit('close')" class="button secondary-button secondary-button--1"><span class="button-text"></span>${content.close}<span class="button-icon"></span></a>
            </div>
        </div>
    </div>
    `}},
    "exit",
    {classes: 'bmi-modal bmi-modal--exit'},
)


export { videoModal, releaseNotesModal, applicationsModal, quickLinksModal, infoModal, patentsModal, tooltipModal, formModal, genericModal, exitModal };
